import { SelectSearchOption } from '../../../../dave-utils-module/select-search/components/select-search/select-search.component';
import { Membership, Qualification } from '../../../mdqx-graphql-types';

export class MembershipEntity implements SelectSearchOption<MembershipEntity> {
    constructor(public Id: number, public Name: string) {}
    get optionLabel() {
        return this.Name;
    }
    static readonly GqlFields: Array<keyof Membership> = ['id', 'name'];
    static fromBackend(res: Membership) {
        return new MembershipEntity(res.id, res.name);
    }
}
